// angular
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// services
import { OrganizationService } from '@core/services';

// addons
import { map, mergeMap, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';

// store
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as actions from './actions';
import * as organizatonActions from '../organization/actions';

// models
import { IOrganization, OrganizationStatus } from '@shared/models';

@Injectable()
export class OrganizationsEffects {
  loadOrganizations$ = createEffect(() => this.actions$.pipe(
    ofType(actions.ActionTypes.Load),
    mergeMap(({ status }: { status: OrganizationStatus }) => {
      return this.organizationService.getOrganizations({ status }).pipe(
        map((organizations: IOrganization[]) => actions.loadSuccess({ organizations })),
        catchError(error => of(actions.loadFail({ error })))
      );
    })
  ));

  loadOrganizationAfterOrganizations$ = createEffect(() => this.actions$.pipe(
    ofType(actions.ActionTypes.LoadSuccess),
    filter(({ organizations }: { organizations: IOrganization[] }) => !this.route.snapshot.fragment),
    map(({ organizations }: { organizations: IOrganization[] }) => {
      if (organizations.length > 0) {
        return organizatonActions.load({ id: organizations[0].id });
      } else {
        return organizatonActions.clear();
      }
    })
  ));

  constructor(
    private actions$: Actions,
    private organizationService: OrganizationService,
    private route: ActivatedRoute,
    private router: Router
  ) {}
}
